export type ColorToken = keyof typeof colorTokens;

export const colorTokens = {
  // Typography
  "$text-primary": "var(--text-primary)",
  "$text-secondary": "var(--text-secondary)",
  "$text-black": "var(--text-black)",
  "$text-white": "var(--text-white)",
  "$text-inverted": "var(--text-inverted)",
  "$text-logo": "var(--text-logo)",

  // Background
  "$background-primary": "var(--background-primary)",
  "$background-secondary": "var(--background-secondary)",
  "$background-tertiary": "var(--background-tertiary)",
  "$background-inverted": "var(--background-inverted)",
  "$background-white": "var(--background-white)",
  "$surface-neutral": "var(--surface-neutral)",

  // Border and dividers
  "$border-distinct": "var(--border-distinct)",
  "$border-subtle": "var(--border-subtle)",
  "$border-subtle-non-darkmode": "var(--border-subtle-non-darkmode)",
  "$border-input": "var(--border-input)",

  // Buttons and links
  "$button-primary": "var(--button-primary)",
  "$button-border": "var(--button-border)",
  "$button-dismissive": "var(--button-dismissive)",
  "$link-primary": "var(--link-primary)",

  // Status
  "$active-highlight": "var(--active-highlight)",
  $notification: "var(--notification)",
  "$surface-success": "var(--surface-success)",
  "$on-surface-success": "var(--on-surface-success)",
  "$surface-highlight": "var(--surface-highlight)",
  "$on-surface-highlight": "var(--on-surface-highlight)",
  "$surface-info": "var(--surface-info)",
  "$on-surface-info": "var(--on-surface-info)",
  "$surface-shared": "var(--surface-shared)",
  "$on-surface-shared": "var(--on-surface-shared)",
  "$error-text": "var(--error-text)",
  "$surface-error-light": "var(--surface-error-light)",
  "$on-surface-error-light": "var(--on-surface-error-light)",

  // Disabled
  "$surface-disabled": "var(--surface-disabled)",
  "$on-surface-disabled": "var(--on-surface-disabled)",
  "$border-disabled": "var(--border-disabled)",

  // States
  "$hover-background": "var(--hover-background)",
  "$button-primary-hover": "var(--button-primary-hover)",
  "$button-dismissive-hover": "var(--button-dismissive-hover)",
  "$button-filled-hover": "var(--button-filled-hover)",
  "$link-primary-hover": "var(--link-primary-hover)",
  "$focus-border": "var(--focus-border)",

  // Green
  "$green-100": "var(--green-100)",
  "$green-150": "var(--green-150)",
  "$green-200": "var(--green-200)",
  "$green-300": "var(--green-300)",
  "$green-400": "var(--green-400)",
  "$green-500": "var(--green-500)",

  // Amber
  "$amber-100": "var(--amber-100)",
  "$amber-200": "var(--amber-200)",
  "$amber-300": "var(--amber-300)",
  "$amber-400": "var(--amber-400)",
  "$amber-500": "var(--amber-500)",

  // Indigo
  "$indigo-100": "var(--indigo-100)",
  "$indigo-200": "var(--indigo-200)",
  "$indigo-300": "var(--indigo-300)",
  "$indigo-400": "var(--indigo-400)",
  "$indigo-500": "var(--indigo-500)",

  // Kivra Extra
  "$kvx-sand100": "var(--kvx-sand100)",
  "$kvx-sand200": "var(--kvx-sand200)",
  "$kvx-gradient01": "var(--kvx-gradient01)",
};
